<h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content class="mat-typography">
  <form class="form-wrapper" [formGroup]="rollenForm" autocomplete=off>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.zeitverwaltung.spesenartDialog.bezeichnung' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.zeitverwaltung.spesenartDialog.bezeichnung' | translate"
        formControlName="bezeichnung"
      />
    </mat-form-field>

      <mat-form-field  appearance="outline" color="accent">
        <mat-label>{{ 'pages.rollenverwaltung.addRollen.rechte' | translate }}</mat-label>
        <mat-select #mySel formControlName="rechte" multiple>
          <mat-option *ngFor="let rechte of ($rechte | async)" [value]="rechte.id">
            {{rechte.code + " " + rechte.bezeichnung}}
          </mat-option>
          <div class="row no-gutters pb-1 buttonPlacement">
            <button
              mat-raised-button
              color="accent"
              (click)="okClicked()"
            >
              {{ data.submitButtonLabel | translate }}
            </button>
          </div>
        </mat-select>
      </mat-form-field>


  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    [tabIndex]="-1"
    id="abbruch"
    color="accent"
    (click)="handleCancelClick()"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="rollenForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
